import Vue from 'vue'
import Vuex from 'vuex'
import { config } from './config';
import { http } from './providers/http';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg',
    baseUrl: config.baseURL,
    drawer: null,
    autenticated:false,
    token: "",
    user:null,
    activeHistorialComprobantes:false,
    solicitudesPermisosPortal: {
      loaded: false,
      pilotActivo: false,
      permitido: true,
    },
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    setToken(state,token){
      state.token = token;
    },
    setUser(state,user){
      state.user = user;
    },
    setAutenticated(state,auth){
      state.autenticated = auth;
    },
    setActiveHistorialComprobantes(state,active){
      state.activeHistorialComprobantes = active
    },
    setSolicitudesPermisosPortal (state, payload) {
      state.solicitudesPermisosPortal = {
        loaded: true,
        pilotActivo: Boolean(payload.pilotActivo),
        permitido: Boolean(payload.permitido),
      }
    },
    resetSolicitudesPermisosPortal (state) {
      state.solicitudesPermisosPortal = {
        loaded: false,
        pilotActivo: false,
        permitido: true,
      }
    },
  },
  actions: {
    async cargarSolicitudesPermisosPortalPilot ({ commit, state }) {
      if (state.solicitudesPermisosPortal.loaded) {
        return state.solicitudesPermisosPortal
      }
      try {
        const response = await http.get('solicitudes-permisos/portal-pilot-acceso')
        const data = response.data || {}
        const payload = {
          pilotActivo: data.pilot_activo === true,
          permitido: data.permitido !== false,
        }
        commit('setSolicitudesPermisosPortal', payload)
        return payload
      } catch (e) {
        commit('setSolicitudesPermisosPortal', {
          pilotActivo: false,
          permitido: true,
        })
        return state.solicitudesPermisosPortal
      }
    },
  },
  getters:{
    autenticated:(state) => {
      return state.autenticated;
    }
  }
})
